import { SettingKey } from "@serophin/nottldr-shared";
import { BookOpen } from "lucide-preact";
import { SettingsCard } from "./SettingsCard";
import { Toggle } from "./Toggle";
import type { SettingsState } from "./useSettingsState";

export const ReadingSettings = ({ settings }: { settings: SettingsState }) => (
  <SettingsCard icon={BookOpen} title="Reading">
    <div class="flex items-center justify-between mb-1">
      <h3 class="text-sm font-medium text-gray-900 dark:text-white">Expand summaries</h3>
      <Toggle
        checked={settings.get(SettingKey.SUMMARY_EXPANDED) === "on"}
        onChange={(on) => settings.change([{ key: SettingKey.SUMMARY_EXPANDED, value: on ? "on" : "off" }])}
      />
    </div>
    <p class="text-xs text-gray-600 dark:text-gray-400">Show the key points of an article open when you read it.</p>
  </SettingsCard>
);
